import React from 'react'
import { Container } from 'react-bootstrap'
import './about.css'
const AboutUs = () => {
    return (
        <Container className='py-5' >
            <h2 className='Heading'>History</h2>
            <hr className='horLine'  />
            <p className='lead' >
            Pakistan Scientific Traders were founded in 1987 by Mr. Ali Ahmad Athar. Initially started the business by providing repair and backup services to Intermediate, Graduate Level and Medical Colleges. After a continuous struggle of three decades by Mr. Ali Ahmad Athar, it made Pakistan Scientific Traders as well-known company.



        </p>

        </Container>
    )
}

export default AboutUs